<template>
  <div class="editable-field">
    <span
      v-if="!editing"
      @click="editing = true"
    >
      {{ value }}
    </span>
    <input
      v-else
      :value="value"
      type="text"
      @input="$emit('input', $event.target.value)"
      @keydown.enter="editing = false"
    >
    <v-btn
      class="pl-4 btn--plain"
      icon
      @click="saveIconClicked"
    >
      <v-icon
        size="20"
        color="#FF854E"
      >
        {{ editing ? "mdi-content-save" : "$pencil" }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "EditableField",
  props: {
    value:{
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      editing: false,
    };
  },
  methods: {
    saveIconClicked() {
      this.editing = !this.editing;
      this.$emit('save', this.value)
    }
  }
};
</script>

<style lang="scss">
.editable-field {
  width: 100%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto 50px;
  input {
    background: white;
    width: 100%;
    &:focus {
      outline: none;
    }
  }
}
</style>
